import React, { useRef, useState, useEffect } from 'react';
import styles from '../edervieiraoficial/edervieiraoficial.module.scss';
import Perfil from './src/perfil.png';
import Link from '../../components/Link/link.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import YoutubeIcon from '../../icons/youtubeIcon.tsx';
import SiteSecondaryIcon from '../../icons/siteSecondaryIcon.tsx';
import SiteIcon from '../../icons/siteIcon.tsx';

const Edervieiraoficial: React.FC = () => {

    return (
        <div className={styles.edervieiraoficial}>

            <div className={styles["body-thunder"]}>
                <div style={{ height: "200px" }} className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <h1>EDER VIEIRA</h1>
                    <p className='mb-0'>Ribeirão Pretano</p>
                    <p>Apaixonado pela vida, viagens e animais.</p>
                    <div className={styles.links}>
                        <Link
                            href="https://youtube.com/@conhecendolugaresnobrasil?si=L4B72b9lVdcyEpOn"
                            title="Conhecendo lugares no Brasil"
                            icon={<YoutubeIcon color="#ffffff" height="32" />}
                            backgroundColor="#383b3d"
                            maxWSpan={true}
                            backgroundColorHover="#000000"
                            colorText="#ffffff"
                        />
                        <Link
                            href="https://conhecendolugaresnobrasil.com.br/"
                            title="Blog"
                            icon={<SiteIcon color="#ffffff" height="32" width="42" />}
                            backgroundColor="#383b3d"
                            maxWSpan={true}
                            backgroundColorHover="#000000"
                            colorText="#ffffff"
                        />
                        <Link
                            href="https://www.instagram.com/edervieiraoficial?igsh=MWF1MWV5Nmc1amx6cA=="
                            title="Instagram"
                            icon={<InstagramIcon color="#ffffff" height="32" />}
                            backgroundColor="#383b3d"
                            maxWSpan={true}
                            backgroundColorHover="#000000"
                            colorText="#ffffff"
                        />
                        <Link
                            href="https://wa.me/5516981019581?text=Olá, gostaria de mais informações sobre consórcio."
                            title="Consórcio Magalu"
                            icon={<WhatsappIcon color="#ffffff" height="40" />}
                            backgroundColor="#383b3d"
                            maxWSpan={true}
                            backgroundColorHover="#000000"
                            colorText="#ffffff"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Edervieiraoficial;
